import React, { useState } from 'react'

interface CostCenter {
  id: string
  code: string
  name: string
  isActive: boolean
}

export function CostCentersRoute() {
  const [costCenters, setCostCenters] = useState<CostCenter[]>([
    { id: 'cc-1', code: 'CC-MKT', name: 'Marketing', isActive: true },
    { id: 'cc-2', code: 'CC-SAL', name: 'Sales', isActive: true },
  ])
  const [newCode, setNewCode] = useState('')
  const [newName, setNewName] = useState('')

  const handleCreate = (e: React.FormEvent) => {
    e.preventDefault()
    if (!newCode || !newName) return
    const newCC: CostCenter = {
      id: `cc-${Date.now()}`,
      code: newCode,
      name: newName,
      isActive: true,
    }
    setCostCenters([...costCenters, newCC])
    setNewCode('')
    setNewName('')
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4 text-gray-900">Cost Centers</h1>
      <p className="text-gray-600 mb-6">Manage cost centers for P&L reporting (₱ PHP).</p>

      <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 mb-8">
        <h2 className="text-lg font-semibold mb-4 text-gray-800">Add New Cost Center</h2>
        <form onSubmit={handleCreate} className="flex gap-4 items-end">
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">Code</label>
            <input
              type="text"
              className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="e.g. CC-MKT"
              value={newCode}
              onChange={e => setNewCode(e.target.value)}
            />
          </div>
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
            <input
              type="text"
              className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="e.g. Marketing"
              value={newName}
              onChange={e => setNewName(e.target.value)}
            />
          </div>
          <button
            type="submit"
            className="px-6 py-2 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 focus:ring-4 focus:ring-blue-100 transition-colors"
          >
            Create
          </button>
        </form>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <table className="w-full text-left">
          <thead className="bg-gray-50 border-b border-gray-100">
            <tr>
              <th className="px-6 py-4 text-sm font-semibold text-gray-900">Code</th>
              <th className="px-6 py-4 text-sm font-semibold text-gray-900">Name</th>
              <th className="px-6 py-4 text-sm font-semibold text-gray-900">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {costCenters.map(cc => (
              <tr key={cc.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 text-sm font-medium text-gray-900">{cc.code}</td>
                <td className="px-6 py-4 text-sm text-gray-600">{cc.name}</td>
                <td className="px-6 py-4">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${cc.isActive ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'}`}>
                    {cc.isActive ? 'Active' : 'Inactive'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
